export const host = 'https://dns.netshops.gr';
